import { LoadablePaint } from '@confluence/loadable';

export const LazyDCScriptMigrationPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DCScriptMigrationPage" */ './DCScriptMigrationPage'
			)
		).DCScriptMigrationPage,
});
